import { createSlice, Middleware } from "@reduxjs/toolkit"
import { IIsStickyActive } from "./types"

type initialState = {
  response: IIsStickyActive | null
}

export const isStickyActiveSlice = createSlice({
  name: "isStickyctive",
  initialState: { response: null } as initialState,
  reducers: {
    setIsStickActive(state, action) {
      state.response = action.payload
    }
  }
})

export const { setIsStickActive } = isStickyActiveSlice.actions
export default isStickyActiveSlice.reducer

export const isStickyActiveHandlerMiddleware: Middleware = () => (next) => (action) => {
  return next(action)
}
